import { CloseIcon } from '@velocity/icons/system';
import { Button } from '@velocity/ui';
import React from 'react';
import { feedbackText } from '../feedback-config';

interface ThankYouProps {
  onClose: () => void;
  isMobile?: boolean;
}

/** Section 5 completion screen shown after a successful submission. */
const ThankYou: React.FC<ThankYouProps> = ({ onClose, isMobile }) => (
  <div className='flex flex-col items-center px-6! py-5! text-center'>
    <h2
      className={`${isMobile ? 'headline-mobile-300' : 'headline-400'} left mb-4! w-full`}
    >
      {feedbackText.thankYou.headline}
    </h2>
    <p
      className={`${isMobile ? 'text-loose-200' : 'text-tight-300'} left mb-8!`}
    >
      {feedbackText.thankYou.description}
    </p>
    <div className='left w-full'>
      <Button
        variant='secondary-filled'
        size='m'
        onClick={onClose}
        data-testid='feedback-close-thankyou'
        StartIcon={CloseIcon}
      >
        {feedbackText.thankYou.close}
      </Button>
    </div>
  </div>
);

export default ThankYou;
